/**
 * Backstage entity annotation keys consumed by the release-manager plugin.
 *
 * @public
 */
export const RELEASE_MANAGER_ANNOTATIONS = {
  /**
   * Enables the Release Manager tab on the entity page.
   * Must be set to "true" on the System entity.
   * Consumed by `isReleaseManagerAvailable` in the frontend plugin.
   *
   * @example
   * open.totvs.io/release-process: yes
   */
  RELEASE_PROCESS: 'open.totvs.io/release-process',

  /**
   * Comma-separated deployment group names for the system.
   * Each group maps to a distinct CI pipeline.
   * A single value keeps the group selector disabled in the UI.
   *
   * @example
   * open.totvs.io/release-group-names: front,query,gerencial
   */
  RELEASE_GROUP_NAMES: 'open.totvs.io/release-group-names',

  /**
   * Override for the CI release pipeline name.
   * When absent, derived as `{namespace}-{systemName}[-{group}]-novo-release`.
   *
   * @example
   * open.totvs.io/release-pipeline-name: supply-engenharia-devx-sandbox-novo-release
   */
  RELEASE_PIPELINE_NAME: 'open.totvs.io/release-pipeline-name',

  /**
   * Override for the CI hotfix pipeline name.
   * When absent, derived as `{namespace}-{systemName}[-{group}]-novo-hotfix`.
   *
   * @example
   * open.totvs.io/hotfix-pipeline-name: supply-engenharia-devx-sandbox-novo-hotfix
   */
  HOTFIX_PIPELINE_NAME: 'open.totvs.io/hotfix-pipeline-name',

  /**
   * Override for the CD deploy pipeline name used when publishing a release.
   * When absent, derived as `{namespace}-{systemName}[-{group}]-cd-prd`.
   *
   * @example
   * open.totvs.io/cd-pipeline-name: supply-engenharia-devx-sandbox-cd-prd
   */
  CD_PIPELINE_NAME: 'open.totvs.io/cd-pipeline-name',
} as const;

/**
 * Label key used on Component entities to declare which release group they belong to.
 * Must match one of the values in `RELEASE_GROUP_NAMES` on the parent System.
 *
 * @example
 * labels:
 *   open.totvs.io/release-group: front
 */
export const RELEASE_GROUP_LABEL = 'open.totvs.io/release-group';
